import { getInvertedColor } from '@elfsight/widget-utils';
import { useSettings } from '@wu/widget-core';

export function useCheckoutColors() {
  const { textColor, fieldAccentColor, background } = useSettings();

  let backgroundColor = background.color;

  if (!backgroundColor || backgroundColor === 'transparent') {
    backgroundColor = getInvertedColor(textColor);
  }

  return {
    textColor,
    accentColor: fieldAccentColor,
    backgroundColor
  };
}
